import React from 'react';
import { View } from 'react-native';
import StepIndicatorButton from '../Buttons/StepIndicatorButton';

//= ========================================================================

const StepIndicatorBar = ({
  titles,
  stepIndex,
  isHollow,
  onCirclePressed,
}) => {
  const myStyles = {
    container: {
      flexDirection: 'row',
      gap: 30,
    },
    blueLine: {
      position: 'absolute',
      marginVertical: 8.5,
      width: stepIndex * 51,
      height: 3,
      backgroundColor: '#008cff',
    },
    greyLine: {
      position: 'absolute',
      marginLeft: stepIndex * 51,
      marginVertical: 8.5,
      width: (titles.length - stepIndex - 1) * 51,
      height: 3,
      backgroundColor: '#edf2f7',
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.blueLine} />
      <View style={myStyles.greyLine} />
      {titles.map((title, index) => (
        <StepIndicatorButton
          title={title}
          index={index}
          stepIndex={stepIndex}
          onCirclePressed={onCirclePressed}
          isHollow={isHollow}
        />
      ))}
    </View>
  );
};
export default StepIndicatorBar;
